<div class="nt-panel__head">
  @if (isPreferences()) {
    <button
      type="button"
      class="nt-panel__back"
      aria-label="Voltar para as notificações"
      data-cy="notifications-back-button"
      (click)="onBack()">
      <lkt-icon name="arrow-left" [size]="18" />
    </button>
  }

  <h2 class="nt-panel__title">{{ heading() }}</h2>

  @if (isList()) {
    <!--
      Achado 4 (Important, fix round final): era `role="tablist"` com dois `role="tab"` e
      `aria-selected`, mas sem `tabpanel`, sem `aria-controls`, sem gestão de `tabindex` e sem
      handler de seta — um padrão ARIA de abas incompleto. Nenhum dos dois botões fica inalcançável
      hoje (os dois são focáveis por Tab), então isto é troca de semântica, não de comportamento:
      um `group` de botões comuns com `aria-pressed`, sem prometer navegação por seta que não existe.
    -->
    <div class="nt-seg" role="group" aria-label="Filtrar notificações">
      <button
        type="button"
        class="nt-seg__opt"
        [class.is-active]="filter() === 'all'"
        [attr.aria-pressed]="filter() === 'all'"
        data-cy="notifications-filter-all"
        (click)="onFilterSelect('all')">
        Todas
      </button>
      <button
        type="button"
        class="nt-seg__opt"
        [class.is-active]="filter() === 'unread'"
        [attr.aria-pressed]="filter() === 'unread'"
        data-cy="notifications-filter-unread"
        (click)="onFilterSelect('unread')">
        Não lidas
      </button>
    </div>

    <!--
      Preferências como ícone encostado no filtro: é ajuste do que se está vendo.
      Só ícone porque a palavra ao lado do segmentado disputa a leitura do
      cabeçalho — daí `title` e `aria-label` carregarem o nome por extenso.
    -->
    <button
      type="button"
      class="nt-panel__cfg"
      title="Preferências de notificação"
      aria-label="Preferências de notificação"
      data-cy="notifications-preferences-button"
      (click)="onPreferences()">
      <lkt-icon name="settings" [size]="17" />
    </button>
  }
</div>

<div class="nt-panel__body">
  <ng-content />
</div>

<!--
  Na vista de preferências o rodapé vem projetado junto do conteúdo (o texto
  "Vale para este dispositivo e todos os outros." é do componente de
  preferências), então a casca só desenha o rodapé da lista.
-->
@if (isList() && showMarkAllRead()) {
  <div class="nt-panel__foot">
    <button
      type="button"
      class="nt-panel__link"
      data-cy="notifications-mark-all-read-button"
      (click)="onMarkAllRead()">
      Marcar todas como lidas
    </button>
  </div>
}
